import Cookie from 'js-cookie'
// 401拦截
const resp401 = {
  /**
   * 响应数据之前做点什么
   * @param response 响应对象
   * @param options 应用配置 包含: {router, i18n, store, message}
   * @returns {*}
   */
  onFulfilled(response, options) {
    const {message} = options
    if (response.code === 401) {
      message.error('无此权限')
    }
    return response
  },
  /**
   * 响应出错时执行
   * @param error 错误对象
   * @param options 应用配置 包含: {router, i18n, store, message}
   * @returns {Promise<never>}
   */
  onRejected(error, options) {
    const {message} = options
    const {response} = error
    if (response.status === 401) {
      message.error('无此权限')
    }
    return Promise.reject(error)
  }
}

const resp403 = {
  onFulfilled(response, options) {
    const {message} = options
    if (response.code === 403) {
      message.error('请求被拒绝')
    }
    return response
  },
  onRejected(error, options) {
    const {message} = options
    const {response} = error
    if (response.status === 403) {
      message.error('请求被拒绝')
    }
    return Promise.reject(error)
  }
}


const respConverter = {
  onFulfilled(response, options) {
    console.log("error", response)
    // console.log("response", response, BASE_URL+"/")
    if (response.headers['content-type']!="application/x-download;charset=utf-8" &&response.headers['content-type'] !='application/msexcel') {//登录功能暂时不动
      if(response.data.status!=200){
        const {message} = options
        message.error(response.data.msg)
        if(response.data.status==401){
          sessionStorage.setItem("redirectUrl",window.location.protocol+"//"+window.location.host+"#/login")
          window.location.href = response.data.data+"?service="+window.location.protocol+"//"+window.location.host+"/auth.html"
        }
        return Promise.reject(response.data.msg)
      }
      return response.data.data;
    } else {
      return response
    }
  },
  onRejected(error, options) {
    const {message} = options
    message.error(error.response.data.msg?error.response.data.msg:'服务器异常')
    console.log("error", error)
    return Promise.reject(error.response.data) // 返回接口返回的错误信息
  }
}


const reqCommon = {
  /**
   * 发送请求之前做些什么
   * @param config axios config
   * @param options 应用配置 包含: {router, i18n, store, message}
   * @returns {*}
   */
  onFulfilled(config, options) {
    const {message} = options
    const {url, xsrfCookieName} = config
    if (url.indexOf('login') === -1 && xsrfCookieName && !Cookie.get(xsrfCookieName)) {
      message.warning('认证 token 已过期，请重新登录')
    }
    return config
  },
  /**
   * 请求出错时做点什么
   * @param error 错误对象
   * @param options 应用配置 包含: {router, i18n, store, message}
   * @returns {Promise<never>}
   */
  onRejected(error, options) {
    const {message} = options
    message.error(error.message)
    return Promise.reject(error)
  }
}

export default {
  request: [reqCommon], // 请求拦截
  response: [resp401, resp403, respConverter] // 响应拦截
}
